import ContainerMd from "../../components/Layouts/ContainerMd";
import { useTranslation } from "react-i18next";
import AppLogo from "../../components/AppLogo";

export default function () {
  const LocalBasePath = "page.policies";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  return (
    <ContainerMd>
      <AppLogo />
      <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
        {t("title")}
      </h2>
    </ContainerMd>
  );
}
